<div class="contact-heading">
  <h2 class="text-center">{{ "pages.contact-us" | translate }}</h2>
</div>
<div class="contact-info">
  <div class="row">
    <div class="col-md-5 contact-info__col">
      <div class="contact-info__card">
        <div class="contact-info__card__image">
          <img
            imgFallback
            loading="lazy"
            fetchpriority="low"
            src="https://media.umangapp.in/cdn/landing/icons/address.svg"
            alt="address"
          />
        </div>
        <div
          style="cursor: pointer"
          (click)="openLocation()"
          class="contact-info__card__content"
        >
          <h6>{{ "dept-details.address" | translate }}</h6>
          <p class="address">
            {{ "contact-us.address" | translate }}
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-4 contact-info__col">
      <div class="contact-info__card">
        <div class="contact-info__card__image">
          <img
            imgFallback
            loading="lazy"
            fetchpriority="low"
            src="https://media.umangapp.in/cdn/landing/icons/email.svg"
            alt="email"
          />
        </div>
        <div class="contact-info__card__content">
          <h6>{{ "contact-us.email" | translate }}</h6>
          <a
            style="cursor: pointer; color: var(--theme-text-color)"
            href="mailto:customercare@umang.gov.in"
            >customercare[at]umang[dot]gov[dot]in</a
          >
        </div>
      </div>
    </div>
    <div class="col-md-3 contact-info__col">
      <div class="contact-info__card">
        <div class="contact-info__card__image">
          <img
            imgFallback
            loading="lazy"
            fetchpriority="low"
            src="https://media.umangapp.in/cdn/landing/icons/support.svg"
            alt="support"
          />
        </div>
        <div class="contact-info__card__content">
          <h6>{{ "benefits.customer-support" | translate }}</h6>
          <a style="color: black" href="tel:10505">
            <p>10505</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
